var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgInstantQuotaitionIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 31,
    height: 31,
    viewBox: "0 0 31 31",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M27.125 7.50781H3.875M15.9844 15.5H3.875M15.9844 23.4922H3.875",
    stroke: "#4A4A4A",
    strokeWidth: 1.69531,
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M18.4062 23.25C18.4062 23.785 18.84 24.2188 19.375 24.2188C19.91 24.2188 20.3438 23.785 20.3438 23.25C20.3438 22.715 19.91 22.2812 19.375 22.2812C18.84 22.2812 18.4062 22.715 18.4062 23.25Z",
    fill: "#4A4A4A"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M23.2966 16.3788C23.4744 16.0191 23.9874 16.0191 24.1651 16.3788L24.4056 16.8653C24.8135 17.6909 25.4044 18.4125 26.1334 18.9753L26.625 19.3549C26.8762 19.5488 26.8762 19.9278 26.625 20.1217L26.1334 20.5013C25.4044 21.0641 24.8135 21.7858 24.4056 22.6114L24.1651 23.0978C23.9874 23.4575 23.4744 23.4575 23.2966 23.0978L23.0562 22.6114C22.6483 21.7858 22.0573 21.0641 21.3284 20.5013L20.8368 20.1217C20.5857 19.9278 20.5857 19.5488 20.8368 19.3549L21.3284 18.9753C22.0573 18.4125 22.6483 17.6909 23.0562 16.8653L23.2966 16.3788Z",
    stroke: "#4A4A4A",
    strokeWidth: 1.69531,
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInstantQuotaitionIcon);
export default __webpack_public_path__ + "static/media/instant-quotaition-icon.b8d7cf18bb636e3973a2069efbdde8e6.svg";
export { ForwardRef as ReactComponent };